import BillService from '../services/bill.service'

// action types
export const POST_BILL = 'PostBill'
export const INITIATE_FUNDING = 'InitiateFunding'

// mutation types
export const SET_BILL = 'SetBill'
export const SET_ERROR = 'SetError'

// state
const state = {
  errors: null,
  billDetails: {}
}

// getters
const getters = {
  currentBill (state) {
    return state.billDetails
  }
}

// actions
const actions = {
  [POST_BILL] (context, billNo) {
    return new Promise((resolve, reject) => {
      BillService.get(billNo)
        .then(response => {
          console.log(response.data)
          context.commit(SET_BILL, response.data.data)
          resolve(response.data)
        })
        .catch(e => {
          reject(e)
          console.log(e)
          if (e.status && e.status === 400) {
            context.commit(SET_BILL, e.message)
          }
          if (e.status && e.status === 404) {
            context.commit(SET_BILL, e.message)
          }
          context.commit(SET_ERROR, e)
        })
    })
  },

  [INITIATE_FUNDING] (context, params) {
    return new Promise((resolve, reject) => {
      BillService.initiateFunding(params)
        .then(response => {
          console.log(response.data)
          context.commit(SET_BILL, response.data.data)
          resolve(response.data)
        })
        .catch(e => {
          reject(e)
          console.log(e)
          context.commit(SET_ERROR, e)
        })
    })
  }
}

// mutations
const mutations = {
  [SET_ERROR] (state, error) {
    state.errors = error
  },

  [SET_BILL] (state, data) {
    state.billDetails = data
    state.errors = {}
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/bill.module.js